export default "__VITE_ASSET__CkqE89Qm__"